import { LocationFragment } from '@graphql/generated';

export const cityAndState = (location?: LocationFragment | null) => {
  if (location?.city && location.state) {
    return `${location.city}, ${location.state}`;
  }
  if (location?.state) {
    return location.state;
  } else {
    return '';
  }
};
export const addressStr = (location: LocationFragment | null | undefined) => {
  let addressStr = '';
  if (location) {
    addressStr += `${location.address1 ? location.address1 + '.' : ''} ${location.state ? `${location.city},` : location.city} ${location.state} ${
      location.postalCode ? ',' + location.postalCode : ''
    }`;
  }
  return addressStr;
};
